import axios from "axios";

import config from "../config/config";
import { getToken } from "../common";

export const fetchAPIListAPI = async () => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}api-keys/`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default fetchAPIListAPI;
